import React from 'react';
import globalColors from "../style/globalColors";

const PageFooter: React.FC = () => {
    return (
        <div style={{
            width: '100%',
            backgroundColor: globalColors.lighterDark2,
            textAlign: 'center',
            padding: '20px 0'
        }}>
            <p style={{
                fontSize: '12px',
            }}
            >{`© ${new Date().getFullYear()} Localify.org and Ithaca College.`}</p>
        </div>
    );
};

export default PageFooter;
